// Show only the trailing characters of the full order ID to keep tables readable.
// Admin supports partial-ID search, so this suffix is enough to identify an order.
const ORDER_ID_DISPLAY_LENGTH = 8;

export const formatOrderId = orderId => (orderId ? orderId.slice(-ORDER_ID_DISPLAY_LENGTH) : null);
